import React from 'react';
import { Box, Stack, Text } from '@chakra-ui/react';
import InvoiceItemCard from 'ts/common/components/invoice/InvoiceItemCard';
import { formatCurrencyValue } from 'ts/common/components/invoice/helpers';
import { useTranslate } from 'ts/common/hooks';

interface Props {
    invoice: SpApi.Client.IInvoice;
}

const ClientInvoiceDiscountCardList: React.FC<Props> = ({ invoice }) => {
    const t = useTranslate('clientInvoice');

    if (invoice.discounts.length === 0) {
        return null;
    }

    return (
        <Box mt={12}>
            <Text fontSize="20px" fontWeight="400" mt={0} mb={4}>
                {t('discounts')}
            </Text>
            <Stack spacing="12px">
                {invoice.discounts.map((discount, index) => (
                    <InvoiceItemCard
                        key={`discount-${index}`}
                        name={discount.name}
                        description={discount.description ?? undefined}
                        leftBottomContent={
                            <Text fontSize="14px" color="gray.600">
                                {discount.discountType === 'fixed'
                                    ? t('discountOff', {
                                          value: formatCurrencyValue(
                                              discount.value,
                                              invoice.currencyCode
                                          )
                                      })
                                    : `${discount.value}% OFF`}
                            </Text>
                        }
                        rightBottomContent={
                            <Text fontWeight="regular" fontSize="16px">
                                -
                                {formatCurrencyValue(
                                    Number(invoice.discountTotal),
                                    invoice.currencyCode
                                )}
                            </Text>
                        }
                    />
                ))}
            </Stack>
        </Box>
    );
};

export default ClientInvoiceDiscountCardList;
